{
  "version": 1,
  "asset_id": "130918e6-545c-45a4-8feb-c2ed30f86d5f",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/130918e6-545c-45a4-8feb-c2ed30f86d5f/clip-img_2357-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/130918e6-545c-45a4-8feb-c2ed30f86d5f/clip-img_2357-poster-sm.webp",
  "original_filename": "clip-img_2357-poster-sm.webp",
  "size": 13758,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:53Z"
}
